import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_MANAGE_UTILITY, APP_FILE_UTILITY } from "./utility.constants";

const Utility = Loadable(
  lazy(() =>
    import("./utility/Utility").then(({ Utility }) => ({
      default: Utility,
    }))
  )
);

const ManageUtility = Loadable(
  lazy(() =>
    import("./utility/UtilitySideBar").then(
      ({ ManageUtility }) => ({
        default: ManageUtility,
      })
    )
  )
);


export const utilityRoutes = [
   {
          path: `${APP_FILE_UTILITY}`,
          exact: true,
          element: (
            <AuthorizedRoute allowFullAccess moduleKeys={[]}>
              <Utility />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_MANAGE_UTILITY}`,
          exact: true,
          element: (
            <AuthorizedRoute allowFullAccess moduleKeys={[]}>
              <ManageUtility />
            </AuthorizedRoute>
          ),
        },
];
